import React from 'react';
import { Box } from '@mui/material';

const BrandsCarousel = () => {
  // Marques de camions - Logos locaux pour fiabilité 100%
  const brands = [
    { 
      name: 'MITSUBISHI',
      logo: '/assets/brands/mitsubishi.svg',
      shadow: 'rgba(220, 20, 60, 0.15)'
    },
    { 
      name: 'SCANIA',
      logo: '/assets/brands/scania.svg',
      shadow: 'rgba(196, 30, 58, 0.15)'
    },
    { 
      name: 'DAF',
      logo: '/assets/brands/daf.png',
      shadow: 'rgba(255, 140, 0, 0.15)'
    },
    { 
      name: 'ISUZU',
      logo: '/assets/brands/isuzu.svg',
      shadow: 'rgba(210, 105, 30, 0.15)'
    },
    { 
      name: 'VOLVO',
      logo: '/assets/brands/volvo.png',
      shadow: 'rgba(178, 34, 34, 0.15)'
    },
    { 
      name: 'RENAULT',
      logo: '/assets/brands/renault.svg',
      shadow: 'rgba(74, 74, 74, 0.15)'
    },
    { 
      name: 'MERCEDES',
      logo: '/assets/brands/mercedes.png',
      shadow: 'rgba(28, 28, 28, 0.15)'
    },
    { 
      name: 'MAN',
      logo: '/assets/brands/man.svg',
      shadow: 'rgba(230, 0, 0, 0.15)'
    },
    { 
      name: 'IVECO',
      logo: '/assets/brands/iveco.svg',
      shadow: 'rgba(0, 51, 153, 0.15)'
    },
    { 
      name: 'FUSO',
      logo: '/assets/brands/fuso.svg',
      shadow: 'rgba(220, 20, 60, 0.15)'
    },
    // Dupliquer pour un défilement continu
    { 
      name: 'MITSUBISHI',
      logo: '/assets/brands/mitsubishi.svg',
      shadow: 'rgba(220, 20, 60, 0.15)'
    },
    { 
      name: 'SCANIA',
      logo: '/assets/brands/scania.svg',
      shadow: 'rgba(196, 30, 58, 0.15)'
    },
  ];

  return (
    <Box
      sx={{
        bgcolor: '#f8fafc',
        py: { xs: 4, md: 5 },
        borderTop: '1px solid #e2e8f0',
        borderBottom: '1px solid #e2e8f0',
        overflow: 'hidden',
        position: 'relative',
      }}
    >
      {/* Conteneur de défilement infini */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: { xs: 4, md: 6 },
          animation: 'scroll 30s linear infinite',
          width: 'max-content',
          '@keyframes scroll': {
            '0%': {
              transform: 'translateX(0)',
            },
            '100%': {
              transform: 'translateX(-50%)',
            },
          },
          '&:hover': {
            animationPlayState: 'paused',
          },
        }}
      >
        {brands.map((brand, index) => (
          <Box
            key={index}
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              minWidth: { xs: '180px', md: '220px' },
              height: { xs: '85px', md: '95px' },
              background: 'linear-gradient(145deg, #ffffff 0%, #f8fafc 100%)',
              borderRadius: '16px',
              border: '1px solid #e2e8f0',
              px: 3,
              py: 2,
              position: 'relative',
              overflow: 'hidden',
              transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
              cursor: 'pointer',
              boxShadow: '0 2px 8px rgba(0, 0, 0, 0.04)',
              '&:hover': {
                transform: 'translateY(-8px) scale(1.05)',
                boxShadow: `0 16px 48px ${brand.shadow}, 0 8px 24px rgba(0, 0, 0, 0.08)`,
                background: 'linear-gradient(145deg, #ffffff 0%, #fefeff 100%)',
                borderColor: '#cbd5e1',
                '& .brand-logo': {
                  transform: 'scale(1.1)',
                  filter: 'brightness(1.1)',
                },
              },
            }}
          >
            <Box
              component="img"
              src={brand.logo}
              alt={`${brand.name} logo`}
              className="brand-logo"
              sx={{
                maxWidth: '80%',
                maxHeight: '60px',
                width: 'auto',
                height: 'auto',
                objectFit: 'contain',
                transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
                filter: 'grayscale(20%) brightness(0.95)',
              }}
            />
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default BrandsCarousel;
